export function parsePlantsFromSearch(search: string): number[] {
  const params = new URLSearchParams(search);
  return (
    params
      .get("plants")
      ?.split(",")
      .map((item) => Number(item))
      .filter((num) => !Number.isNaN(num)) ?? []
  );
}

export function parseSizesFromSearch(search: string): string[] {
  const params = new URLSearchParams(search);
  return params.get("sizes")?.split(",").filter(Boolean) ?? [];
}
